import { render, staticRenderFns } from "./Step3-terrace.vue?vue&type=template&id=493ec5ef&scoped=true&"
import script from "./Step3-terrace.vue?vue&type=script&lang=js&"
export * from "./Step3-terrace.vue?vue&type=script&lang=js&"
import style0 from "./Step3-terrace.vue?vue&type=style&index=0&id=493ec5ef&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493ec5ef",
  null
  
)

export default component.exports